import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericApiError } from '@/_shared/types/apiError';
import { GenericGet } from '@/_shared/types/swagger';
import { getCurrentOrganization } from '@/core/state';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_COLORS_PATH_KEY } from '@/swagger/constants/slash-keys';
import { API_GET_ASPECT_COLORS_CALL, KEY_GET_ASPECT_COLORS } from '../constants';
import { MOCK_RESPONSE_GET_ASPECT_COLORS } from '../mocks';
import { Colors } from '../types';

export type ResponseGetAspectColors = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_COLORS_PATH_KEY
>['response']['body'];

type CallParamsGetAspectColors = {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseGetAspectColors = {
  colors: Colors[];
};

type CallErrorGetAspectColors = GenericApiError;

type CallSelectorsGetAspectColors = unknown;

export const getAspectColorsCall = createGeneralCall<
  CallParamsGetAspectColors,
  CallResponseGetAspectColors,
  CallErrorGetAspectColors,
  CallSelectorsGetAspectColors
>({
  id: KEY_GET_ASPECT_COLORS,
  method: 'get',
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_GET_ASPECT_COLORS_CALL(org);
  },
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_GET_ASPECT_COLORS
    : undefined,
});
